export type OfferType = "discount" | "pause";

export const offerTypes: OfferType[] = ["discount", "pause"];

export const selectOfferTypes = offerTypes.map((type) => ({
  value: type,
  label: type.charAt(0).toUpperCase() + type.slice(1),
}));

export const colorsByOfferType: Record<OfferType, string> = {
  discount: "green",
  pause: "indigo",
};
